import { Box, Card, Container, Grid, Typography } from "@mui/material";
import { motion } from "framer-motion";
import React from "react";
import SvgCard from "../../components/SvgCard";
import {
  BlueSection,
  SectionCentent,
  SectionTitle,
  SubTitle,
} from "../../styles/HomeStyles";

const WhoWeAre = () => {
  return (
    <BlueSection>
      <Container>
        <Grid justifyContent="center" alignItems="center" container spacing={2}>
          <Grid item xs={12} sm={7}>
            <SectionTitle>Qui Sommes Nous:</SectionTitle>
            <SectionCentent>
              <SubTitle mr={0.5} variant="body">
                AFRIQUALEOS
              </SubTitle>
              est un cabinet de conseil en management
              <SubTitle mx={0.5} variant="body">
                QHSE
              </SubTitle>
              ( <b>Qualité, Hygiène, Sécurité</b> et
              <b> Environnement</b> ) et en organisation, qui a une orientation
              africaine due à l'expérience de ses experts qui ont mené plusieurs
              missions pour des entreprises en Afrique, à savoir au Maroc, Mali,
              Burkina Faso, Niger, Gabon, République du Congo et autres…, et qui
              vise d'autres pays pour le déploiement de ses expertises et le
              développement de son sens pluriculturel et pluridisciplinaire.
            </SectionCentent>
            <SectionCentent>
              <SubTitle mr={0.5} variant="body">
                AFRIQUALEOS
              </SubTitle>
              vous propose une multitude de prestations et vous invite à
              découvrir ses domaines d'expertise à travers cette présentation.
            </SectionCentent>
          </Grid>
          <Grid item xs={12} sm={5}>
            <SvgCard
              color="white"
              src="./static/images/TiltCards/who_are_we.jpg"
              distance="40px"
            />
          </Grid>
        </Grid>
      </Container>
    </BlueSection>
  );
};

export default WhoWeAre;
